import Link, { LinkProps } from '@components/common/Link';
import React, { useMemo } from 'react';
import { Container, IconContainer } from './QuestionLink.styles';
import { IconDiscord, IconDoc } from '@components/icons';

interface QuestionLinkProps extends LinkProps {
  type: 'doc' | 'discord';
}

export const QuestionLink = ({ type, ...rest }: QuestionLinkProps) => {
  const iconType = useMemo(() => {
    if (type === 'doc')
      return {
        label: 'Read User Docs',
        type: <IconDoc />,
      };
    if (type === 'discord')
      return {
        label: 'Chat with us on Discord',
        type: <IconDiscord />,
      };
  }, [type]);

  return (
    <Container>
      <IconContainer>{iconType.type}</IconContainer>
      <Link {...rest}>{iconType.label}</Link>
    </Container>
  );
};
